import styled from "styled-components";

export const ContainerBody = styled.div`
  min-height: 100vh;
  width: 100vw;
  max-width: 1920px;
  background-color: #000;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
